/**
 * Lightweight structured logger with environment-aware level gating.
 *
 * Usage:
 *   import { createLogger } from "../utils/logger";
 *   const log = createLogger("WS");
 *   log.info("Connected");          // → [WS] Connected
 *   log.error("Parse error:", e);   // → [WS] Parse error: ...
 *
 * Configure via VITE_LOG_LEVEL env var: DEBUG | INFO | WARN | ERROR | SILENT
 * Defaults to DEBUG in development, WARN in production builds.
 */

const LEVELS = { DEBUG: 0, INFO: 1, WARN: 2, ERROR: 3, SILENT: 4 };
const METHODS = { DEBUG: "debug", INFO: "info", WARN: "warn", ERROR: "error" };

function resolveLevel() {
  const env = import.meta.env.VITE_LOG_LEVEL?.toUpperCase();
  if (env && env in LEVELS) return LEVELS[env];
  return import.meta.env.PROD ? LEVELS.WARN : LEVELS.DEBUG;
}

const currentLevel = resolveLevel();

export function createLogger(name) {
  function emit(level, ...args) {
    if (LEVELS[level] < currentLevel) return;
    console[METHODS[level]](`[${name}]`, ...args);
  }

  return {
    debug: (...args) => emit("DEBUG", ...args),
    info: (...args) => emit("INFO", ...args),
    warn: (...args) => emit("WARN", ...args),
    error: (...args) => emit("ERROR", ...args),
    log: (...args) => emit("INFO", ...args),
  };
}

export const logger = createLogger("agentic");
